import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-panel-layout',
  imports: [],
  templateUrl: './panel-layout.component.html',
  styleUrl: './panel-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PanelLayoutComponent {}
